var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import * as DeliveryMethodFactory from "../../classes/definitions/deliveryMethod/deliveryMethod";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import DeliveryMethodsList from '../../components/DeliveryMethods/DeliveryMethodsList/DeliveryMethodsList';
import AppRoutes from '../../config/appRoutes';
import DashboardsReduxProps from "./DeliveryMethodsReduxProps";
var DeliveryMethods = /** @class */ (function (_super) {
    __extends(DeliveryMethods, _super);
    function DeliveryMethods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: []
        };
        _this.getAllDeliveryMethods = function () {
            _this.api.getDeliveryMethods()
                .then(function (response) {
                var methods = DeliveryMethodFactory.createDeliveryMethods(response.data);
                _this.setState({ data: methods });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим методите за доставка.', _this.props.history);
            });
        };
        _this.toNewDeliveryMethod = function () {
            _this.props.history.push(AppRoutes.deliveryMethod.path);
        };
        _this.toFreeShipping = function () {
            _this.props.history.push(AppRoutes.freeShipping.path);
        };
        return _this;
    }
    DeliveryMethods.prototype.componentDidMount = function () {
        this.getAllDeliveryMethods();
    };
    DeliveryMethods.prototype.componentWillUnmount = function () {
        // TODO
    };
    DeliveryMethods.prototype.render = function () {
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041C\u0435\u0442\u043E\u0434\u0438 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewDeliveryMethod, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u043C\u0435\u0442\u043E\u0434 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430")),
                        React.createElement(DeliveryMethodsList, { gridData: data }))),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toFreeShipping, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u0410\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0431\u0435\u0437\u043F\u043B\u0430\u0442\u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430")))))));
    };
    return DeliveryMethods;
}(React.Component));
export default connect(null, DashboardsReduxProps.mapDispatchToProps)(DeliveryMethods);



//////////////////
// WEBPACK FOOTER
// ./src/views/DeliveryMethods/DeliveryMethods.tsx
// module id = 343
// module chunks = 0